import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    if (this.dialogTarget.open) {
      this.dialogTarget.close()
    }
  }

  // Submit handler — fired by form's data-action.
  // Closes the sheet before the submit completes so the redirect lands
  // on the cart with no stale dialog state.
  closeBeforeSubmit() {
    this.close()
  }
}
